import "@shopify/polaris/build/esm/styles.css";
import "./pages/styles/main.css";
import "./pages/styles/polaris-tweaks.css";
import "./ui/styles.css";
import ReactGA from "react-ga4";
import * as ReactDOM from "react-dom/client";

import React from "react";
import App from "./App";
import { BrowserRouter } from "react-router";
import { IS_PROD } from "./utils/constants";
import { registerStaleChunkReload } from "./lib/staleChunkReload";
import { applyOneTimeToken } from "./lib/oneTimeToken";

const root = document.getElementById("root");

if (IS_PROD) {
  ReactGA.initialize("G-5922V7R1YM", {
    titleCase: false
  });
}

registerStaleChunkReload();
applyOneTimeToken(window.location);

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
